"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(require("./TableHead"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/TableHead/index.js
 ** module id = 399
 ** module chunks = 0
 **/